import { useMutation } from '@tanstack/react-query'

import { submitCompletedWorkflowOfPaymentRequests } from '@src/api'
import { DefaultApiSubmitCompletedWorkflowOfPaymentRequestsRequest } from '@src/api/generated/user-api'
import { useAxios } from '@src/hooks/use-axios'

export const useSubmitCompletedWorkflowOfPaymentRequests = () => {
  const { axiosInstance } = useAxios()

  return useMutation({
    mutationFn: (
      params: DefaultApiSubmitCompletedWorkflowOfPaymentRequestsRequest
    ) => submitCompletedWorkflowOfPaymentRequests(axiosInstance, params),
  })
}
